module.exports = __webpack_public_path__ + "static/img/quote.8bb116e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/quote.png
// module id = 1J+S
// module chunks = 1